<div class="gl-d-flex date-range">
  <div class="form-field">
    <mat-form-field appearance="outline" controlErrorContainer>
      <mat-label i18n>Дата приемки</mat-label>
      <mat-date-range-input [rangePicker]="pickerReceive">
        <input matStartDate [formControl]="fromControl" formControlErrors placeholder="Начальная" />
        <input matEndDate [formControl]="toControl" placeholder="Конечная" />
      </mat-date-range-input>
      <app-datepicker-toggler
        matSuffix
        *ngIf="!fromControl.value"
        [datepicker]="pickerReceive"
      ></app-datepicker-toggler>
      <mat-datepicker-toggle *ngIf="fromControl.value" matSuffix (click)="clear()">
        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #pickerReceive></mat-date-range-picker>
    </mat-form-field>
  </div>
</div>
